module.exports = __webpack_public_path__ + "media/images/icon__plus@3x-089a7ce6a1a7332900a345292bc56b6e.png";